import { z } from "zod";

export const getModificationTemplateFormSchema = z.object({
  ledgerId: z.string().trim().min(1, "formData.forms.errors.required"),
  accountId: z.string().trim().min(1, "formData.forms.errors.required"),
});

export type GetModificationTemplateFormType = z.infer<
  typeof getModificationTemplateFormSchema
>;
